<template>
  <div class="outStock">
    <!-- “outStock”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
      @projectChange="projectChange"
      @periodChange="periodChange"
    >
    </sirui-search>
    <!-- outStock -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog
      :title="this.$t('outStock.form.importType')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="350px"
    >
      <base-form
        v-model="baseData"
        :options="options"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="100px"
      ></base-form>
      <el-radio-group v-model="radio" class="importType">
        <el-radio v-for="(item, index) in optionsImport" :key="index" :label="item.value">{{
          item.label
        }}</el-radio>
      </el-radio-group>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="handleImport()">{{
          $t('dialog.confirm')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/outStock';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import siruiUpload from '@/components/SiruiUpload';
  // import DictSpan from '@/components/DictSpan';
  // import SearchTable from '@/components/form-item/search-table';
  import baseForm from '@/components/form/base-form';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'outStock',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      siruiUpload,
      // DictSpan,
      // SearchTable,
      baseForm,
      // Check,
      // Merge,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 状态 => 用于表格回显
        requestStatusData(state) {
          let dictList = state.dict.dictList;
          if (dictList.length > 0) {
            return dictList.find((it) => it.dictType == 'request_status').dictList;
          } else {
            return [];
          }
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   部门
          {
            name: this.$t('outStock.search.outboundDepartmentName'),
            prop: 'outboundDepartmentName',
            type: 'input',
            // querySearch: this.productCodeSearch
          },
          //   产品名称
          {
            name: this.$t('outStock.search.productName'),
            prop: 'productName',
            type: 'input',
            // querySearch: this.productCodeSearch
          },
          //   创建人
          {
            name: this.$t('outStock.search.createBy'),
            prop: 'createBy',
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
            clearable: true,
            //querySearch: this.productCodeSearch
          },
          //   创建日期
          {
            name: this.$t('outStock.search.gmtCreate'),
            prop: 'gmtCreate',
            type: 'date',
            //querySearch: this.productCodeSearch
          },
          //   品牌
          {
            name: this.$t('outStock.search.productBrand'),
            prop: 'productBrand',
            type: 'input',
            // querySearch: this.productCodeSearch
          },
          //   规格型号
          {
            name: this.$t('outStock.search.productSpec'),
            prop: 'productSpec',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   产品类别
          {
            name: this.$t('outStock.search.productType'),
            prop: 'productType',
            type: 'dict',
            dictType: 'product_type',
            //querySearch: this.productCodeSearch
          },
          //   其他
          {
            name: this.$t('outStock.search.otherInfo'),
            prop: 'otherInfo',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   购货单位
          {
            name: this.$t('outStock.search.customerName'),
            prop: 'customerName',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   发货日期
          {
            name: this.$t('outStock.search.deliveryDate'),
            prop: 'deliveryDate',
            type: 'date',
          },
          //   出库类型
          {
            name: this.$t('outStock.search.outboundType'),
            prop: 'outboundType',
            type: 'dict',
            dictType: 'outbound_type',
          },
          {
            // 项目名称
            name: this.$t('outStock.search.projectName'),
            prop: 'projectCode',
            type: 'dict',
            dictType: 'produce_product_proname',
            changeMethod: 'projectChange',
          },
          {
            // 结算周期
            prop: 'periodName',
            name: this.$t('outStock.search.periodName'),
            type: 'searchTableSpec',
            searchType: 'pdPeriod',
            isMultiple: true,
            extraData: {
              projectCode: this.searchForm.projectCode,
            },
            currentValue: this.searchForm.periodName,
            changeMethod: 'periodChange',
          },
        ];
      },
      options() {
        return [
          {
            // 成本确认账期
            prop: 'periodName',
            label: this.$t('outStock.label.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            span: 18,
            extraData: {
              projectCode: this.baseData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.baseData.periodName,
          },
        ];
      },
    },
    data() {
      return {
        dialogAdd: false,
        loading: false,
        optionsImport: [
          {
            value: '01',
            label: this.$t('outStock.options.domesticTrade'),
          },
          {
            value: '02',
            label: this.$t('outStock.options.generalTrade'),
          },
          {
            value: '03',
            label: this.$t('outStock.options.feedProcessing'),
          },
        ],
        radio: '',
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        searchForm: {
          outboundDepartmentName: '',
          productName: '',
          createBy: '',
          gmtCreate: '',
          productBrand: '',
          productSpec: '',
          productType: '',
          otherInfo: '',
          customerName: '',
          deliveryDate: '',
          outboundType: '',
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
        },
        baseData: {
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //账期编码
          periodName: null, //账期
          outboundType: null, //导出出库类型
        },

        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          //订单单号
          { field: 'orderNo', title: 'outStock.label.orderNo', visible: true, width: 140 },
          //出库公司
          {
            field: 'outboundCompanyName',
            title: 'outStock.label.outboundCompanyName',
            visible: true,
            width: 180,
          },
          //出库部门
          {
            field: 'outboundDepartmentName',
            title: 'outStock.label.outboundDepartmentName',
            visible: true,
            width: 140,
          },
          //账期名称
          { field: 'periodName', title: this.$t('outStock.label.periodName') },
          //项目
          { field: 'projectName', title: 'outStock.label.projectName', visible: true, width: 140 },
          //销售含税单价
          {
            field: 'productPriceWithTax',
            title: 'outStock.label.productPriceWithTax',
            visible: true,
            width: 140,
          },
          //出库单号
          { field: 'outboundNo', title: 'outStock.label.outboundNo', visible: true, width: 140 },
          //单位
          {
            field: 'productUnit',
            title: 'outStock.label.productUnit',
            visible: true,
            width: 140,
            dictType: 'produce_basic_unit',
          },
          //购货单位
          {
            field: 'customerName',
            title: 'outStock.label.customerName',
            visible: true,
            width: 140,
          },
          //销售金额
          { field: 'salesAmount', title: 'outStock.label.salesAmount', visible: true, width: 140 },
          //发货日期
          {
            field: 'deliveryDate',
            title: 'outStock.label.deliveryDate',
            visible: true,
            width: 140,
          },
          //实发数量
          {
            field: 'productCount',
            title: 'outStock.label.productCount',
            visible: true,
            width: 140,
          },
          //发货仓库
          {
            field: 'warehouseName',
            title: 'outStock.label.warehouseName',
            visible: true,
            width: 140,
          },
          //商品编码
          { field: 'productCode', title: this.$t('outStock.label.productCode') },
          //产品名称
          { field: 'productName', title: 'outStock.label.productName', visible: true, width: 140 },
          //规格型号
          { field: 'productSpec', title: 'outStock.label.productSpec', visible: true, width: 140 },
          //品牌
          {
            field: 'productBrand',
            title: 'outStock.label.productBrand',
            visible: true,
            width: 140,
          },
          //产品类别
          {
            field: 'productType',
            title: 'outStock.label.productType',
            visible: true,
            width: 140,
            dictType: 'product_type',
          },
          //其他
          { field: 'otherInfo', title: 'outStock.label.otherInfo', visible: true, width: 140 },
          //校准型号
          /* { field: "productSpecAdjust", title: 'outStock.label.productSpecAdjust', visible: true, width: 140 }, */
          //单位净重
          {
            field: 'singleWeight',
            title: 'outStock.label.singleWeight',
            visible: true,
            width: 140,
          },
          //总净重
          { field: 'totalWeight', title: 'outStock.label.totalWeight', visible: true, width: 140 },
          //批号
          { field: 'batchNo', title: 'outStock.label.batchNo', visible: true, width: 140 },
          //币种
          {
            field: 'currencyName',
            title: 'outStock.label.currencyName',
            visible: true,
            width: 140,
            dictType: 'trade_currency',
          },
          //加工流水号
          {
            field: 'processSerialNo',
            title: 'outStock.label.processSerialNo',
            visible: true,
            width: 140,
          },
          //售后类型
          {
            field: 'afterSalesType',
            title: 'outStock.label.afterSalesType',
            visible: true,
            width: 140,
          },
          //运输方式
          { field: 'shipMode', title: 'outStock.label.shipMode', visible: true, width: 140 },
          //出库类型
          {
            field: 'outboundType',
            title: 'outStock.label.outboundType',
            visible: true,
            width: 140,
            dictType: 'outbound_type',
          },
          //备注
          { field: 'remark', title: 'outStock.label.remark', visible: true, width: 140 },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      // this.getDictList();
      //this.getProductCodeList(),
      //this.getProductNameList(),
      //this.getProductConfirmNameList(),
      this.$nextTick(() => {
        //查询列表数据
        this.getData();
        //动态获取查询结果按钮及表头
        this.getButtonList();
        //设置导入参数
        this.setImport();
      });
    },
    methods: {
      // 获取列表数据
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag, tenantCode, companyCode, departmentCode } = this.userInfo;
        let params = { pageNum, pageSize, adminFlag, tenantCode, companyCode, departmentCode };
        params = Object.assign(params, this.searchForm);
        params.createBy = params.createBy ? params.createBy[0].id : null;
        this.$axios.post(API.LIST_OUTSTOCK_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 获取产品编号列表
      getProductCodeList() {
        const params = {
          cloumn: 'productCode',
          productClass: '0',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productCodeList = res.data.data;
          }
        });
      },
      // 获取产品名称列表
      getProductNameList() {
        const params = {
          cloumn: 'productName',
          productClass: '1',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productNameList = res.data.data;
          }
        });
      },
      // 校准名称列表
      getProductConfirmNameList() {
        const params = {
          cloumn: 'productName',
          productClass: '1',
        };
        this.$axios.get(API.PD_SELECT_OPTION_ALIAS, params).then((res) => {
          if (res.data.code === 0) {
            this.productConfirmNameList = res.data.data;
          }
        });
      },
      // 模糊查询
      productCodeSearch(queryString, cb) {
        const productCodeList = this.productCodeList;
        const results = queryString
          ? productCodeList.filter(this.createFilter(queryString))
          : productCodeList;
        cb(results);
      },
      createFilter(queryString) {
        return (data) => {
          return data.value.indexOf(queryString) !== -1;
        };
      },
      getDictList() {
        // 公司名称
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      projectChange() {
        // 切换项目
        this.searchForm.periodCode = this.searchForm.periodName = null;
      },
      periodChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.searchForm.periodCode = res[0].periodCode;
          this.searchForm.periodName = res[0].periodName;
        } else {
          this.searchForm.periodCode = this.searchForm.periodName = null;
        }
        if (res[0].periodStatus == 'closed') {
          //关闭的账期不能对数据进行增删改
          this.menuButtonList.forEach((item) => {
            if (['del'].indexOf(item.attributes.buttonUrl) > -1) {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        }
      },
      chooseClick(value) {
        if (value === 'add') {
          //增加
          this.handleAdd();
        } else if (value === 'importData') {
          //批量导入
          this.dialogAdd = true;
        } else if (value === 'exportData') {
          //批量导出
          this.handleExport();
        } else if (value === 'del') {
          //批量删除
          this.handleForbid();
        }
      },
      // 新增
      handleAdd() {
        let path = {
          path: '/production/productionDataAdd',
          name: 'productionDataAdd',
          meta: {
            keepAlive: true,
            title: '新增成品出库明细',
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      /* handleExport() {
      let tableColumn = this.$refs.siruiTable.getTableColumn().visibleColumn;
      let showColumns = [];
      let idList=[];
      tableColumn.forEach(item => {
        if (item.property) showColumns.push({prop: item.property});
      });
      if(this.multipleSelection.length>0){
         this.multipleSelection.forEach(item => {
           idList.push(item.id);
       });
      }
      const {tenantCode, companyCode, departmentCode} = this.userInfo;
      let params = { tenantCode, companyCode, departmentCode };
      params = Object.assign(params, this.searchForm);
      params.columns = showColumns
      params.ids=idList;
      this.$axios.post(API.LIST_OUTSTOCK_EXPORT, params).then(res => {
        if(res.data.code === 0) {
          window.location.href = res.data.data;
        }
      })
    }, */
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'idList=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.LIST_OUTSTOCK_EXPORT}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.LIST_OUTSTOCK_EXPORT}?${params}&access_token=${this.token.access_token}`;
        }
      },
      handleForbid() {
        if (this.multipleSelection.length > 0) {
          let ids = [];
          for (let item of this.multipleSelection) {
            ids.push(item.id);
          }
          this.$confirmAction(this.$t('confirm.delete'))
            .then(() => {
              this.$axios.post(API.LIST_OUTSTOCK_DELETE, ids).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('outStock.message.deleteSuccess'),
                    type: 'success',
                  });
                  this.multipleSelection = [];
                  this.$refs.siruiTable.clearCheckboxRow();
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('outStock.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.LIST_OUTSTOCK_IMPORT;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
        };
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      // 批量导入
      handleImport() {
        let baseData = this.exportBaseData();
        if (baseData) {
          if (this.radio == '') {
            this.$message({
              showClose: true,
              message: this.$t('outStock.message.noSelectError'),
              type: 'error',
            });
            return;
          }
          this.baseData.outboundType = this.radio;
          this.importData = Object.assign(this.importData, this.baseData);
          this.$refs.siruiUpload.openDialog(true);
          this.dialogAdd = false;
        }
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'projectCode') {
          this.baseData.periodCode = this.baseData.periodName = null;
          this.baseData.projectCode = value.projectCode;
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.baseData.projectCode = res[0].projectCode;
            this.baseData.projectName = res[0].projectName;
            this.baseData.periodCode = res[0].periodCode;
            this.baseData.periodName = res[0].periodName;
          } else {
            this.baseData.periodCode = this.baseData.periodName = null;
          }
        }
      },
      dblclickEvent() {},
      changeCompany() {},
    },
  };
</script>
<style lang="scss" scoped>
  .importType {
    display: block;
    width: 100%;
    margin-left: 30%;
    .el-radio {
      height: 30px;
      margin-right: 0px;
      display: block;
    }
  }
</style>
